.actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.head2 {
    margin-bottom: 15px;
    font-weight: 500;
    font-size: 24px;
}

.header {
    margin: 30px auto 25px auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 32px;
}

.itemsRow {
    display: flex;
    column-gap: 25px;
    height: 75px;
    margin: 5px auto;
    padding: 5px;
    overflow-x: auto;
}

.itemsColumn2 {
    flex: 50%;
}

.section {
    margin-bottom: 30px;
    padding: 30px 50px 30px 50px;
    background: var(--background-card);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.07);
    border-radius: 5px
}